import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import Scrolltrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(Scrolltrigger);
gsap.config({ nullTargetWarn: false, });


//SP
let menuFlg = false;
let inquiryFlg = false;

$(document).on('click', '.sp-header .menu-btn', function () {
  let $this = $(this);
  let $target = $('nav.menu');
  let $target2 = $('nav.inquiry-menu');
  $this.find('.menu-trigger').stop().toggleClass('active');

  if (menuFlg == false) {
    if (inquiryFlg == true) {
      gsap.to($target2, {
        autoAlpha: 0,
        duration: 0.3
      });
      inquiryFlg = false;
    }
    gsap.to($target, {
      autoAlpha: 1,
      duration: 0.3
    });
    $('body').addClass('menu-opend');
    if (!$('body').hasClass('hold-head')) {
      if (!$('.sp-header').hasClass('is-scrolled')) {
        $('.sp-header').find('.logo1 img').attr('src', function (index, attr) {
          return attr.replace('logo_wh.svg', 'logo.svg');
        });
      }
    }
    menuFlg = true;
  } else {

    gsap.to($target, {
      autoAlpha: 0,
      duration: 0.3
    });
    $('body').removeClass('menu-opend');
    if (!$('body').hasClass('hold-head')) {
      if (!$('.sp-header').hasClass('is-scrolled')) {
        $('.sp-header').find('.logo1 img').attr('src', function (index, attr) {
          return attr.replace('logo.svg', 'logo_wh.svg');
        });
      }
    }
    menuFlg = false;
  }
  return false;
});

$(document).on('click', '.sp-header .inquiry-btn', function () {
  let $this = $(this);
  let $target = $('nav.inquiry-menu');
  let $target2 = $('nav.menu');
  //$this.find('.menu-trigger').stop().toggleClass('active');

  if (inquiryFlg == false) {
    if (menuFlg == true) {
      gsap.to($target2, {
        autoAlpha: 0,
        duration: 0.3
      });
      $('.menu-trigger').removeClass('active');
      menuFlg = false;
    }
    gsap.to($target, {
      autoAlpha: 1,
      duration: 0.3
    });
    $('body').addClass('menu-opend');
    if (!$('.sp-header').hasClass('is-scrolled')) {
      $('.sp-header').find('.logo1 img').attr('src', function (index, attr) {
        return attr.replace('logo_wh.svg', 'logo.svg');
      });
    }
    inquiryFlg = true;
  } else {

    gsap.to($target, {
      autoAlpha: 0,
      duration: 0.3
    });
    //$(this).find('.word').removeClass('active');
    $('body').removeClass('menu-opend');
    if (!$('.sp-header').hasClass('is-scrolled') && !$('body').hasClass('hold-head')) {
      $('.sp-header').find('.logo1 img').attr('src', function (index, attr) {
        return attr.replace('logo.svg', 'logo_wh.svg');
      });
    }
    inquiryFlg = false;
  }
  return false;
});

$(window).on('load scroll', function () {
  let $tar = $('.sp-header');
  if ($(this).scrollTop() > 200) {
    if (!$tar.hasClass('is-scrolled')) {
      $tar.addClass('is-scrolled');
    }
    if (!$('body').hasClass('hold-head')) {
      $tar.find('.logo1 img').attr('src', function (index, attr) {
        return attr.replace('logo_wh.svg', 'logo.svg');
      });
    }
  } else {
    if ($tar.hasClass('is-scrolled')) {
      $tar.removeClass('is-scrolled');
    }
    if (!$('body').hasClass('hold-head')) {
      $tar.find('.logo1 img').attr('src', function (index, attr) {
        return attr.replace('logo.svg', 'logo_wh.svg');
      });
    }
  }
});

//PC
$(window).on('load scroll', function () {
  let $tar = $('.pc-header');
  if ($(this).scrollTop() > 200) {
    if (!$tar.hasClass('is-scrolled')) {
      $('.pc-header').addClass('is-scrolled');
      gsap.to($('.inquiry-content'), {
        autoAlpha: 0,
        duration: 0.3
      });
      inquiryFlg = false;
    }
  } else {
    if ($tar.hasClass('is-scrolled')) {
      $('.pc-header').removeClass('is-scrolled');
      gsap.to($('.inquiry-content'), {
        autoAlpha: 0,
        duration: 0.3
      });
      inquiryFlg = false;
    }
  }
});

// $('.pc-header .inquiry-btn').on('mouseenter', function () {
//   let $target = $('.pc-header').find('.inquiry-content');
//   gsap.to($target, {
//     autoAlpha: 1,
//     duration: 0.3
//   });
// });
$('.pc-header .inquiry-btn .btn').on('click', function () {
  let $target = $('.pc-header').find('.inquiry-content');
  if (inquiryFlg == false) {
    gsap.to($target, {
      autoAlpha: 1,
      duration: 0.3
    });
    inquiryFlg = true;
  } else {
    gsap.to($target, {
      autoAlpha: 0,
      duration: 0.3
    });
    inquiryFlg = false;
  }
  return false;
});

// $('.p-top .mv-sec .inquiry-btn').on('mouseenter', function () {
//   let $target = $('.p-top .mv-sec').find('.inquiry-content');
//   gsap.to($target, {
//     autoAlpha: 1,
//     duration: 0.3
//   });
// });
if (!$('body').hasClass('.hold-head')) {
  $('.mv-sec .inquiry-btn .btn').on('click', function () {
    let $target = $('.mv-sec').find('.inquiry-content');
    if (inquiryFlg == false) {
      gsap.to($target, {
        autoAlpha: 1,
        duration: 0.3
      });
      inquiryFlg = true;
    } else {
      gsap.to($target, {
        autoAlpha: 0,
        duration: 0.3
      });
      inquiryFlg = false;
    }
    return false;
  });
}
// $('.pc-header .inquiry-btn').on('mouseleave', function () {
//   let $target = $('.pc-header').find('.inquiry-content');
//   gsap.to($target, {
//     autoAlpha: 0,
//     duration: 0.3
//   });
// });
// $('.p-top .mv-sec .inquiry-btn').on('mouseleave', function () {
//   let $target = $('.p-top .mv-sec').find('.inquiry-content');
//   gsap.to($target, {
//     autoAlpha: 0,
//     duration: 0.3
//   });
// });



if ($('body').hasClass('.hold-head')) {
  $('.sp-header').find('.logo1 img').attr('src', function (index, attr) {
    return attr.replace('logo_wh.svg', 'logo.svg');

  });
}



